
export default class SubnavBarAutoScrollerController {
  constructor (element) {
    this._element = element
    this._bindUIActions()
    this._scrollContainer = this._element.querySelector('.subnav-bar__menu__scroll-container')
    this._scrollee = this._element.querySelector('.subnav-bar__menu__list')
  }

  notifyChange () {
    console.log('notify change')

    const activeElement = this._element.querySelector('.subnav-bar__menu__item--active')
    console.log('activeElement', activeElement)
    this.centerElement(activeElement)
  }

  centerElement (element) {
    console.log('this._scrollee', this._scrollee)
    if (element && this._scrollContainer && this._scrollee) {
      const scrollContainerPosition = this._scrollContainer.getBoundingClientRect()
      const scrolleePosition = this._scrollee.getBoundingClientRect()
      const lastElement = this._element.querySelector('.subnav-bar__menu__item:last-child')
      const lastElementPosition = lastElement.getBoundingClientRect()
      const elementPosition = element.getBoundingClientRect()

      console.log('scrolleePosition', scrolleePosition)
      console.log('elementPosition', elementPosition)

      const elementX = elementPosition.x - scrolleePosition.x
      console.log('elementX', elementX)

      console.log(lastElementPosition)
      console.log(lastElementPosition.x)
      console.log(lastElement.width)
      const scrolleeLength = lastElementPosition.x - scrolleePosition.x + lastElementPosition.width
      const maxOffset = (scrolleeLength - scrollContainerPosition.width + 15) * -1

      console.log('scrolleeLength', scrolleeLength)
      console.log('maxOffset', maxOffset)

      let scrolleeOffset = (scrollContainerPosition.width / 2) + (-1 * elementX)
      scrolleeOffset = Math.max(Math.min(scrolleeOffset, 0), maxOffset)

      this._scrollee.style.transform = `translate(${scrolleeOffset}px,0)`

      // const activeElementOffset = scrolleePosition.l
    }
  }

  _bindUIActions () {

  }
}
